import React from 'react';

// Facilities in the new portal. Its search, sort and paging state all live in
// the URL, but every param defaults to exactly what this link would have
// spelled out (facility search, newest first, 25 per page) — so the bare path
// is the whole link, and a param list can't drift out of date here. The path
// was /fleet/sites until the new portal renamed the section to Facilities; it
// serves no redirect from the old name.
const FACILITIES_PATH = '/fleet/facilities';

// The new portal is a separate SPA on its own host, so this can never be a
// react-router link — it is a real navigation out of this app. The host is
// per-environment; where the var is unset there is no new portal to send
// anyone to, and `routes.js` leaves the route unregistered (which also drops
// the item from the sidebar, since SideNavbar only renders registered routes).
export const facilitiesUrl = () => `${(process.env.REACT_APP_PORTAL_V2_URL || '').replace(/\/$/u, '')}${FACILITIES_PATH}`;

// An interstitial rather than a bare outbound link: the destination is a
// different portal on a different domain, and leaving without a word makes
// that look like a bug. One click is the price of saying so.
//
// Both actions are anchors, not buttons with an onClick — a real link can be
// opened in a new tab, copied, or followed from the keyboard, none of which a
// scripted navigation allows. Same shape as Support's `support__portal-button`,
// which is the other outbound link in this app.
const NewPortalFacilities = () => {
    const url = facilitiesUrl();

    return (
        <div className="card-wrapper new-portal">
            <h3 className="card-wrapper__title">The new Emulate portal</h3>
            <p className="new-portal__body">
                Facilities is the first page of the new portal we are rolling out, so it lives on its own site rather than in here. It opens with the
                sign-in you are already using — you will not be asked for your password or one-time code again.
            </p>
            <div className="new-portal__actions">
                <a className="new-portal__open" href={url}>
                    Open Facilities
                </a>
                <a className="new-portal__new-tab" href={url} target="_blank" rel="noreferrer">
                    Open in a new tab
                </a>
            </div>
            <p className="new-portal__hint">
                If the new portal opens but says you have no access, your account is not switched on for it yet — tell us and we will enable it.
            </p>
        </div>
    );
};

export default NewPortalFacilities;
